import React from 'react';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import AnimationInlineHoc from '../AnimationOverlay/AnimationInline';
import './GameInstructionsContent.css';
import { useStore } from '@hmpu/powerups.store';

export function GameInstructionsContent() {
  const { __t } = useTranslation('SETTINGS_PANEL');
  // const [bodyCopy1, bodyCopy1Sub] = __t('bodyCopy1').split(`\n\n`);
  const bodyCopy1 = __t('howToPlayBodyCopy');
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);

  const handleAnimationComplete = () => {
    console.log('Animation completed');
  };

  return (
    <div className="game-instructions-content">
      <div className="game-instructions-text">
        <p className="subparagraph-instructions">{bodyCopy1}</p>
        {/* <p className="paragraph-instructions">
          <i>{bodyCopy1Sub}</i>
        </p> */}
        <br></br>
      </div>
      {/* @ts-ignore */}
      {/* <div className="game-instructions-lottie">
        {!showSettingsPanel ? (
          <AnimationInlineHoc
            name="TUTORIAL"
            type="LOTTIE"
            url={__t('lottieFile')}
            unique={true}
            loop={true}
            style={{
              width: '100vw',
              height: 'auto',
              marginTop: '-5%',
              marginBottom: '-5%',
            }}
            // onComplete={handleAnimationComplete}
            onLoopComplete={handleAnimationComplete}
          />
        ) : null}
      </div>*/}
    </div>
  );
}
